import dayjs from 'dayjs';
import _ from 'lodash';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { normalizeSearchString } from '../../utils/normalizeSearchString';
import {
  VEHICLE_FIRST_STEP_FIELD_TYPES,
  VEHICLE_SECOND_STEP_FIELD_TYPES,
  VEHICLE_THIRD_STEP_FIELD_TYPES,
  VEHICLE_FIFTH_STEP_FIELD_TYPES,
  VEHICLE_ADD_MODALS_TYPES,
} from './constants';
import { WIENTJES_INSTALATION } from '../../containers/App/constants';
import env from '../../env';
import { AppClientId } from '../Shared/constants';
import {
  EXTERIOR_ATTENTION_OPTIONS,
  INTERIOR_ATTENTION_OPTIONS,
  TECHNICAL_ATTENTION_OPTIONS,
} from '../KanbanBoards/constants';

dayjs.extend(customParseFormat);

export const parseVehicle = function(vehicle, index) {
  let props = {};

  if (vehicle.props)
    props = _(vehicle.props)
      //.keyBy('name')
      .mapValues('value')
      .value();

  for (let i = 0; i < vehicle?.properties?.length; ++i) {
    let name = vehicle.properties[i]?.propertyName?.name || vehicle.properties[i]?.propertyValue?.vehiclePropertyName?.name;
    props[name] = vehicle.properties[i].propertyValue?.value;
  }

  delete props.id;
  delete props.created_at;

  const hiddenPropsForSearch = [
    'transported_vehicles'
  ];

  let search = Object.keys(props)
    .filter(key => !hiddenPropsForSearch.includes(key))
    .map(key => normalizeSearchString(props[key]))
    .join('|');

  let v = { ...vehicle, ...props, search };

  Object.keys(v).forEach(key => {
    if (key.indexOf('inspection_attention_incident_') === 0) {
      console.log(key);
      try {
        v[key] = JSON.parse(v[key]);
      } catch (error) {
        //
      }
    }
  });

  return v;
};

export const parseVehicleTasks = function(tasks) {
  let obj = {};

  tasks?.map(task => {
    if (!obj[task.department]) {
      obj[task.department] = [task];
    } else {
      obj[task.department] = [...obj[task.department], task];
    }
  });

  return obj;
};

export const resetProperties = function(step) {
  if (!step) {
    return;
  }
  if (step === 1) {
    return VEHICLE_FIRST_STEP_FIELD_TYPES;
  }

  if (step === 2) {
    return VEHICLE_SECOND_STEP_FIELD_TYPES;
  }

  if (step === 3) {
    return VEHICLE_THIRD_STEP_FIELD_TYPES;
  }

  if (step === 4) {
    return [];
  }

  if (step === 5) {
    return VEHICLE_FIFTH_STEP_FIELD_TYPES;
  }

  if (step == 'addModal') {
    return VEHICLE_ADD_MODALS_TYPES;
  }
};

export const getDate = function(date, withTime) {
  // eslint-disable-next-line no-extra-boolean-cast

  // TODO: temporary solution, needs to correct all dates format
  if (date === 'null') return;

  let parsedDate = !!date ? dayjs(date, 'DD-MM-YYYY').format('DD-MM-YYYY') : '-';
  let parsedTime = '';

  if (withTime) {
    let time = date?.slice(date.indexOf('T'));

    parsedDate = !!date ? dayjs(date, 'DD-MM-YYYY').format('DD-MM-YYYY') : '-';
    parsedTime = !!date ? dayjs(time, 'HH:mm').format('HH:mm') : '-';
  }
  if (parsedDate == 'Invalid Date') {
    parsedDate = !!date ? dayjs(date).format('DD-MM-YYYY') : '-';
  }
  return withTime ? `${parsedDate} ${parsedTime}` : parsedDate;
};

export const getVehicleAge = function(dateFirstAllowance) {
  if (!dateFirstAllowance) return;
  const currentYear = dayjs(new Date(Date.now())).format('YYYY');
  const firstAllowanceYear = dayjs(dateFirstAllowance, 'DD-MM-YYYY')?.format('YYYY');

  return +currentYear - +firstAllowanceYear;
};

export const getSirvSpinUrl = function(vehicleId, spin, isSlideIndicator) {
  if (env.disable_SIRV) return null;
  return isSlideIndicator
    ? `https://indewal.sirv.com/ID/${vehicleId}/exterior/0${spin}/0${spin}.spin?autospin=off&spinOnAnyDrag=false&fullscreen=false&hint=false&zoom=0&reverseRotation=off`
    : `https://indewal.sirv.com/ID/${vehicleId}/exterior/0${spin}/0${spin}.spin`;
};

export const getSirvImgUrlInterior = function(vehicleId, val) {
  if (env.disable_SIRV) return null;
  return `https://indewal.sirv.com/ID/${vehicleId}/interior/${val}.jpg`;
};

export const getSirvImgUrlExterior = function(vehicleId) {
  if (env.disable_SPIN) return null;
  //todo: implement interior URL
  return `https://indewal.sirv.com/ID/${vehicleId}/exterior/01/${vehicleId}-01-01-29.jpg`;
};

export const getImgUrlExterior = function(vehicleId) {
  if (env.disable_SPIN) return `https://indewal.sirv.com/ID/${vehicleId}/exterior/01/${vehicleId}-01-01-29.jpg`;
  //todo: implement interior URL
  // return `https://indewal.sirv.com/ID/${vehicleId}/exterior/01/${vehicleId}-01-01-29.jpg`;
  return `https://vindat.indewal.nl/storage/documents/spin/${vehicleId}/1-29.jpg`;
};

export const getStorageImage = function(vehicleId) {
  if (env.clientId === AppClientId.INDEWAL) {
    return `https://vindat.indewal.nl/storage/documents/spin/${vehicleId}/1-7.jpg`;
  }
};

export function validateImageSrc(vehicleId) {
  const promise = new Promise((resolve, reject) => {
    let image = document.createElement('img');
    let validUrl = null;
    image.src = getStorageImage(vehicleId);
    image.onload = () => {
      validUrl = true;
      console.log('validUrl, ', validUrl);
      resolve(validUrl);
    };
    image.onerror = () => {
      validUrl = false;
      resolve(validUrl);
    };
  });
  return promise;
}

export const formatFinancialAmounts = function(properties) {
  const financialAmountsTypes = [
    'financial_purchase_price_marge_bpm',
    'financial_purchase_price_marge_excl_bpm',
    'rest_bpm',
    'financial_price_b2b_incl_vat_btpm',
    'financial_price_b2c',
    'financial_price_gross_incl_btw_bpm',
    'financial_price_nett_excl_vat_bpm',
    'financial_bpm_gross',
    'vat_base',
    'financial_purchase_price_incl_vat_bpm',
    'financial_purchase_price_incl_vat_excl_bpm',
    'vat_amount',
    'financial_purchase_price_excl_vat_excl_bpm',
    'outgoing_rest_bpm',
    'vat_percentage',
  ];

  for (let i = 0; i < properties.length; i++) {
    const property = properties[i];
    const name = property?.propertyName;
    const value = property?.propertyValue;

    if (financialAmountsTypes.includes(name)) {
      property.propertyValue = formatAmount(value);
    }
  }

  return properties;
};

export const formatAmount = function(amount) {
  if (typeof amount != 'string') return amount;
  let newAmount = amount?.replace(',', '.');

  newAmount = parseFloat(newAmount);

  if (isNaN(newAmount)) {
    newAmount = null;
  }

  return newAmount;
};

export const isWithInstallation = function(appClientId, installation) {
  switch (installation) {
    case WIENTJES_INSTALATION.APP_CLIENT_NAME:
      return appClientId == WIENTJES_INSTALATION.APP_CLIENT_ID;
    default:
      return false;
  }
};

// export const getVehicleStatusLabel = function(status, lbl) {
//   // Check if lbl is a function

//   if (typeof lbl !== 'function') {
//     console.log(status + 'status');
//     return 'Unknown Status'; // Provide a fallback label
//   }

//   // Default label based on status
//   let label = lbl(`vehicle.property.status.${status || 0}`);

//   // Handle specific client cases
//   if (
//     (status == 1 || status == 'consigment') &&
//     (env.clientId === AppClientId.HOOIKAMMER || env.clientId === AppClientId.AUTOHUISSALLAND)
//   ) {
//     label = env.vehicle_status_1;
//   }

//   // Check again for the same condition and override label
//   if (
//     (status == 1 || status == 'consigment') &&
//     (env.clientId === AppClientId.HOOIKAMMER || env.clientId === AppClientId.AUTOHUISSALLAND)
//   ) {
//     label = lbl('vehicle.property.hooikammer_status.1');
//   }

//   // If vehicle exists, add additional logic (if needed)
//   if (vehicle) {
//     if (env.clientId === AppClientId.HOOIKAMMER) {
//       // Example conditions to change label based on vehicle properties
//       if (vehicle?.HOOI_uitslag_done) {
//         label = 'Uitgeslagen';
//       } else if (!vehicle?.HOOI_inslag_done_date) {
//         label = 'te Verwachten';
//       } else if (vehicle?.HOOI_inslag_done_date && !vehicle?.HOOI_uitslag_done_date) {
//         label = 'Ingeslagen';
//       }
//       if (!vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized == '1') {
//         label = 'Verkocht ingeslagen';
//       }
//       if (vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized == '1') {
//         label = 'Verkocht uitgeslagen';
//       }
//     }
//   }

//   return label;
// };

export const getVehicleStatusLabel = function(status, lbl, vehicle) {
  // Check if lbl is a function

  if (typeof lbl !== 'function') {
    console.log(status + 'status');
    return 'Unknown Status'; // Provide a fallback label
  }

  // Default label based on status
  let label = lbl(`vehicle.property.status.${status || 0}`);

  // Handle specific client cases
  if (
    (status == 1 || status == 'consigment') &&
    (env.clientId === AppClientId.HOOIKAMMER || env.clientId === AppClientId.AUTOHUISSALLAND)
  ) {
    label = env.vehicle_status_1;
  }

  // Check again for the same condition and override label
  if (
    (status == 1 || status == 'consigment') &&
    (env.clientId === AppClientId.HOOIKAMMER || env.clientId === AppClientId.AUTOHUISSALLAND)
  ) {
    label = lbl('vehicle.property.hooikammer_status.1');
  }

  if (env.clientId === AppClientId.HILTERMANN && status == 6) {
    label = env.vehicle_status_6;
  }

  if (env.clientId === AppClientId.HILTERMANN && status > 6) {
    label = lbl(`vehicle.property.status.extra.${status}`);
  }

  // If vehicle exists, add additional logic (if needed)
  if (vehicle) {
    if (env.clientId === AppClientId.HOOIKAMMER) {
      // Example conditions to change label based on vehicle properties
      if (vehicle?.HOOI_uitslag_done) {
        label = 'Uitgeslagen';
      } else if (!vehicle?.HOOI_inslag_done_date) {
        label = 'te Verwachten';
      } else if (vehicle?.HOOI_inslag_done_date && !vehicle?.HOOI_uitslag_done_date) {
        label = 'Ingeslagen';
      }
      if (!vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized == '1') {
        label = 'Verkocht ingeslagen';
      }
      if (vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized == '1') {
        label = 'Verkocht uitgeslagen';
      }
    }
  }

  return label;
};

export const getExpiryDateColor = function(date) {
  if (!date) return '';
  const dateParts = date.split('-');
  const apkExpiryDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);

  const today = new Date();
  const twoMonthsFromNow = new Date();
  twoMonthsFromNow.setMonth(today.getMonth() + 2);

  let color = '';

  if (apkExpiryDate < today) {
    color = 'red-text';
  } else if (apkExpiryDate >= today && apkExpiryDate <= twoMonthsFromNow) {
    color = 'orange-text';
  }

  return color;
};

export const formatterDistance = new Intl.NumberFormat('en-US', {
  style: 'unit',
  unit: 'kilometer',
  unitDisplay: 'short',
  maximumFractionDigits: 0,
});

export const getDaysInStock = function(vehicle) {
  // Helper function: Parse dates from dd-mm-yyyy or ISO 8601
  const parseDate = dateStr => {
    if (!dateStr) return null;

    const ddMMyyyyRegex = /^(\d{2})-(\d{2})-(\d{4})(?:\s(\d{2}):(\d{2})(?::(\d{2}))?)?$/;
    const match = dateStr.match(ddMMyyyyRegex);

    if (match) {
      const [, day, month, year, hours = '0', minutes = '0', seconds = '0'] = match;
      return new Date(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes), Number(seconds));
    }

    // If date in  ISO 8601
    return new Date(dateStr);
  };

  const calculateDaysDifference = (start, end) => {
    let diffInMilliseconds = end - start;
    if (env.clientId === AppClientId.HOOIKAMMER) {
      diffInMilliseconds += 86400000;
    }
    const days = Math.floor(diffInMilliseconds / 86400000); // 1 day = 86400000 ms
    return days > -1 ? days : 'Geen inslag';
  };

  if (env.clientId === AppClientId.HOOIKAMMER) {
    const { HOOI_inslag_done_date, HOOI_uitslag_done_date } = vehicle;

    const inslagDate = parseDate(HOOI_inslag_done_date) || new Date();
    const uitslagDate = parseDate(HOOI_uitslag_done_date) || new Date();

    const days = calculateDaysDifference(inslagDate, uitslagDate);

    return days;
  }

  const createdAt = new Date(vehicle.createdAt);
  const daysSinceCreation = calculateDaysDifference(createdAt, new Date());
  return daysSinceCreation;
};
export const getIncidentOptions = function(attentionType, lbl) {
  let partsOptions = [];
  let typesOptions = [];
  let solutionsOptions = [];

  if (attentionType === 'exterior') {
    partsOptions = EXTERIOR_ATTENTION_OPTIONS.parts;
    typesOptions = EXTERIOR_ATTENTION_OPTIONS.types;
    solutionsOptions = EXTERIOR_ATTENTION_OPTIONS.solutions;
  }

  if (attentionType === 'interior') {
    partsOptions = INTERIOR_ATTENTION_OPTIONS.parts;
    typesOptions = INTERIOR_ATTENTION_OPTIONS.types;
    solutionsOptions = INTERIOR_ATTENTION_OPTIONS.solutions;
  }

  if (attentionType === 'technical') {
    partsOptions = TECHNICAL_ATTENTION_OPTIONS.parts;
    typesOptions = TECHNICAL_ATTENTION_OPTIONS.types;
    solutionsOptions = TECHNICAL_ATTENTION_OPTIONS.solutions;
  }
  let part = partsOptions?.map(part => ({
    value: part,
    label: lbl('inspection.attention.part.' + part),
  }));

  let type = typesOptions?.map(type => ({
    value: type,
    label: lbl('inspection.attention.type.' + type),
  }));

  let solution = solutionsOptions?.map(solution => ({
    value: solution,
    label: lbl('inspection.attention.solution.' + solution),
  }));

  return {
    part,
    type,
    solution,
  };
};

export const getVehicleTaskOpen = function(vehicle) {
  const tasks = [
    'task_desticker',
    'task_nijboer',
    'task_AVN',
    'task_polish_exterior',
    'task_interior_polish',
    'task_interior_repair',
    'task_int_ext_polish',
    'task_restyle',
    'task_spot_repair',
    'task_spray',
    'task_window_repair',
    'task_repair',
    'task_service',
    'task_recall',
    'task_apk',
    'task_adjust',
    'task_attach_parts',
    'task_hartstad',
    'task_ijsseldelta',
  ];

  const vehicleTasks = tasks.filter(task => ['1', '2', '3'].includes(vehicle[task]));

  if (vehicleTasks.length > 0) {
    return vehicleTasks;
  }
  if (vehicle.task_attach_replate === '1' && vehicle.task_attach_replate_done === null) {
    return ['task_attach_replate'];
  }
  return [];
};

export const getTotalTradeInAmount = function(tradeInVehicles) {
  if (!tradeInVehicles?.length) return 0;
  const price = tradeInVehicles?.reduce((acc, curr, currentIndex) => (acc += +curr?.price), 0);

  return price;
};
